import { Card, CardImage, H5, H6 } from "@sellar-io/components";
import { DiscoverySupplierListResponseType } from "@sellar-io/api-v2/types";
import { ProfilePicture } from "../../../components";
import { Badge } from "../../../components/badge/Badge";

import { twMerge } from "tailwind-merge";

/**
 * {
 *  id: number;
 *  imageUrl: strin | null;
 *  containerTypes: string[];
 *  Business: {
 *    logoUrl: string | null;
 *    name: string;
 *    DeliveryAddress: {
 *      city: string;
 *       region: string;
 *    }
 *  }
 * }
 */
interface DiscoveryListSupplierType extends Pick<
  DiscoverySupplierListResponseType[number],
  "id" | "imageUrl" | "containerTypes"
> {
  Business: Pick<
    DiscoverySupplierListResponseType[number]["Business"],
    "logoUrl" | "name"
  > & {
    DeliveryAddress: Pick<
      DiscoverySupplierListResponseType[number]["Business"]["DeliveryAddress"],
      "city" | "region"
    >;
  };
}

export const DiscoveryListSupplierCard = ({
  supplier,
  onClick,
  className,
}: {
  supplier: DiscoveryListSupplierType;
  onClick: () => void;
  className?: string;
}) => {
  return (
    <Card
      key={supplier.id}
      className={twMerge(
        "bg-white",
        "relative cursor-pointer snap-center",
        className,
      )}
      onClick={onClick}
    >
      <CardImage imageUrl={supplier.imageUrl ?? ""} fallback="supplier-hero" />
      <div className={"flex flex-col gap-4 p-4"}>
        <div className="flex">
          <ProfilePicture
            size={"large"}
            logoUrl={supplier.Business.logoUrl}
            name={supplier.Business.name}
            className="mr-2 rounded-full border-2 border-white bg-white"
            fallback="supplier-badge"
          />
          <div className={"flex flex-col"}>
            <H5 className="overflow-hidden text-ellipsis whitespace-nowrap">
              {supplier.Business.name}
            </H5>
            <H6
              className={
                "overflow-hidden text-ellipsis whitespace-nowrap text-gray-500"
              }
            >
              {[
                supplier.Business.DeliveryAddress.city,
                supplier.Business.DeliveryAddress.region,
              ]
                .filter(Boolean)
                .join(", ")}
            </H6>
          </div>
        </div>
        <div className={"flex w-full gap-1"}>
          {supplier.containerTypes.map((container, i) => (
            <Badge key={i}>{container}</Badge>
          ))}
        </div>
      </div>
    </Card>
  );
};
